import { VAT_STATE_KEY, VatState } from './vat-reducer';

export enum VAT_ACTION_TYPE {
  SET_VAT_STATE = 'SET_VAT_STATE',
  CALL_VATADD = 'CALL_VATADD',
}

export type SetVatStateAction<KeyName extends keyof VatState> = {
  type: VAT_ACTION_TYPE.SET_VAT_STATE;
  payload: { key: KeyName, value: VatState[KeyName] };
};


export type VatActions = SetVatStateAction<VAT_STATE_KEY>;
